const body = {
  label: 'Body',
  name: 'body',
  component: 'text',
  defaultValue:
    'Get clean and safe water on-the-go with our double-walled bottle',
};
export default body;
